import { isOpenPartnerIncentiveModal } from "@/atoms/user/is-open-partner-incentive-modal";
import { ButtonColor } from "@/common/enum/button-color";
import { Button, Modal, TextInput } from "flowbite-react";
import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { userService } from "../../services/user-service";
import { CustomHelperText } from "../CustomHelperText";
import { CustomDatepicker } from "../datepicker/CustomDatepicker";
import { TextInputLabel } from "../label/TextInputLabel";
import { H4 } from "../typography/H4";

export const PartnerIncentiveModal = () => {
  const [isModal, setIsModal] = useRecoilState(isOpenPartnerIncentiveModal);
  const [startDate, setStartDate] = useState<Date | undefined>(new Date());
  const [endDate, setEndDate] = useState<Date | undefined>(undefined);
  const [rate, setRate] = useState<string>("");
  const [isExpanded, setIsExpanded] = useState(false);

  const isSubmitDisabled = !(startDate && endDate && rate);

  const handleTextInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (/^\d*$/.test(value)) {
      setRate(value);
    }
  };

  const closeModal = () => {
    setIsModal(undefined);
  };

  const handleSubmit = async () => {
    if (!startDate || !endDate) {
      return;
    }

    if (!isModal) {
      return;
    }

    try {
      startDate.setHours(0, 0, 0, 0);
      const response = await userService.incentiveDiscounts(isModal.user.id, {
        fromDate: startDate.toISOString(),
        toDate: endDate.toISOString(),
        discountRate: Number(rate),
        itemIds: [isModal.itemId],
        delete: false,
      });

      if (!response.ok) {
        alert("두자리 숫자로 입력해주세요.");
        return;
      }
      isModal.getPage(isModal.searchItemName);
      closeModal();
    } catch (error) {
      console.error(error);
    }
    // setModal({
    //   open: false,
    //   startDate,
    //   endDate,
    // });
  };

  const handleStartDate = (date: Date) => {
    date.setHours(0, 0, 0, 0);
    setStartDate(date);
  };

  const handleEndDate = (date: Date) => {
    date.setHours(23, 59, 59, 999);
    setEndDate(date);
  };

  const handleFocus = () => {
    setIsExpanded(true);
  };

  useEffect(() => {
    setIsExpanded(false);
  }, [startDate, endDate]);

  return (
    <Modal size="2xl" show={true} onClose={closeModal}>
      <Modal.Header className="p-[24px] h-[76px]">
        <H4>인센티브 할인 기간 설정</H4>
      </Modal.Header>
      <Modal.Body className="overflow-visible">
        <div className="flex justify-center">
          <div className="flex flex-col">
            <div className="flex flex-col gap-[20px]">
              <div className="flex items-center gap-[8px]">
                <div className="flex flex-col w-full" onFocus={handleFocus}>
                  <TextInputLabel
                    required
                    className="mb-[4px] text-semantic-text-heading"
                  >
                    할인 시작일
                  </TextInputLabel>
                  <CustomDatepicker
                    selectedDate={startDate}
                    maxDate={endDate}
                    onDateChange={handleStartDate}
                  />
                </div>
                <div className="flex flex-col w-full" onFocus={handleFocus}>
                  <TextInputLabel
                    required
                    className="mb-[4px] text-semantic-text-heading"
                  >
                    할인 종료일
                  </TextInputLabel>
                  <CustomDatepicker
                    selectedDate={endDate}
                    minDate={startDate}
                    onDateChange={handleEndDate}
                    placeholder="종료일 선택"
                  />
                </div>
              </div>
              <div>
                <TextInputLabel required>
                  기간 동안 적용할 할인율을 입력해주세요.
                </TextInputLabel>
                <TextInput
                  className="w-[572px]"
                  placeholder="0%"
                  name="road"
                  value={rate}
                  onChange={handleTextInputChange}
                />
              </div>
              <CustomHelperText
                isError={false}
                text={"기간이 지날 경우 이전 할인율이 적용됩니다."}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={isSubmitDisabled}
          color={isSubmitDisabled ? ButtonColor.DISABLED : ButtonColor.PRIMARY}
          onClick={handleSubmit}
          // size={"xl"}
        >
          적용하기
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
